<template>
    <span class="text-body-2"> {{ numberWithCommas($t('results', { count: countNumber })) }} </span>
</template>

<script setup lang="ts">
import { readonly, toRefs } from 'vue';
import { numberWithCommas } from '../../utils/types/numberWithCommas';

export interface Props {
    count?: number;
}
const props = withDefaults(defineProps<Props>(), {
    count: 0,
});
const { count } = toRefs(props);

const countNumber = readonly(count);
</script>
